<template>
  <div class="form-page">
    <header class="form-page-header">
      <div class="form-page-titles">
        <h1>{{ title }}</h1>
        <p v-if="description">{{ description }}</p>
      </div>
      <div v-if="$slots.controls" class="form-page-controls">
        <slot name="controls" />
      </div>
    </header>
    <div class="form-page-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormPage',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
  },
}
</script>

<style scoped>
.form-page {
  background: #f5f7fb;
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-height: 100%;
  padding: 24px;
}

.form-page-header {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.form-page-titles h1 {
  color: #1f2937;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 6px;
}

.form-page-titles p {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
}

.form-page-controls {
  align-items: center;
  display: flex;
  gap: 10px;
}

.form-page-body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
}

@media (max-width: 720px) {
  .form-page-header {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
